import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { genUnitValueFormatter } from "../tabellen/Tabellen";
import { genComponentFormatterLong } from "../model/util/Components";

const VolumenUndLeckage = props => {
	if ((props.leckage_und_volumen === undefined) || (props.leckage_und_volumen === [] || props.leckage_und_volumen.length === 0))
		return <span/>;
	else
		return (
			<div>
				<Table.Provider columns={[{
					property: "cindex",
					cell: { formatters: [ genComponentFormatterLong(props.compressors, props.intl) ] },
					header: {
						label: props.intl.formatMessage({ id: "Component" })
					}
				}, {
					property: "leaked_volume",
					cell: { formatters: [ genUnitValueFormatter("volume", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Leakage" })
					}
				}, {
					property: "leakage_cost",
					cell: { formatters: [ genUnitValueFormatter("currency", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Cost" })
					}
				}, {
					property: "leakage_co2_equivalent",
					cell: { formatters: [ genUnitValueFormatter("mass", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "CO² equivalent"})
					}
				}]}>
					<Table.Header />
					<Table.Body rows={props.leckage_und_volumen} rowKey="cindex" />
				</Table.Provider>
				<Table.Provider columns={[{
					property: "cindex",
					cell: { formatters: [ genComponentFormatterLong(props.compressors, props.intl) ] },
					header: {
						label: props.intl.formatMessage({ id: "Component" })
					}
				}, {
					property: "total_volume",
					cell: { formatters: [ genUnitValueFormatter("volume", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Volume" })
					}
				}, {
					property: "volume_cost",
					cell: { formatters: [ genUnitValueFormatter("currency", props.units, props.intl, true) ]},
					header: {
						label: props.intl.formatMessage({ id: "Cost" })
					}
				}, {
					property: "volume_cost_per_unit",
					cell: { formatters: [ genUnitValueFormatter("currency_over_volume", props.units, props.intl, true)]},
					header: {
						label: props.intl.formatMessage({ id: "Specific cost"})
					}
				}]}>
					<Table.Header />
					<Table.Body rows={props.leckage_und_volumen} rowKey="cindex" />
				</Table.Provider>
			</div>);
};

VolumenUndLeckage.propTypes = {
	leckage_und_volumen: PropTypes.arrayOf(PropTypes.object).isRequired,
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
	units: PropTypes.object.isRequired,
	intl: intlShape.isRequired
};

export default injectIntl(VolumenUndLeckage);
